import { cn } from '@/lib/utils'

interface FramedWordmarkProps {
  className?: string
  dark?: boolean
}

/**
 * Text-based "framed" wordmark using Bricolage Grotesque font
 * with yellow accent bar above the text.
 */
export function FramedWordmark({ className, dark }: FramedWordmarkProps) {
  return (
    <span
      className={cn(
        'inline-flex flex-col items-start select-none leading-none',
        className
      )}
    >
      <span className="bg-framed-yellow rounded-full self-stretch h-[0.15em] mb-[0.1em]" />
      <span
        className={cn(
          'font-display font-bold tracking-tight',
          dark ? 'text-white' : 'text-[#313131]',
        )}
      >
        framed
      </span>
    </span>
  )
}

interface FramedIconProps {
  className?: string
  dark?: boolean
}

/**
 * Text-based "f" icon using Bricolage Grotesque font.
 * Used as a compact logo mark.
 */
export function FramedIcon({ className, dark }: FramedIconProps) {
  return (
    <span
      className={cn(
        'font-display font-semibold select-none leading-none',
        dark ? 'text-white' : 'text-[#313131]',
        className
      )}
    >
      f
    </span>
  )
}
